export default __webpack_public_path__ + "static/media/headerCircle.6903346a.svg";